export const bankOperations = state => {
    return state.bankOperationsSelected;
};
export const RDOperations = state => {
    return state.RDOperationsSelected;
};
export const groupedSelected = state => {
    return state.groupedSelected;
};
export const uuidGroupedSelected = state => {
    return state.uuidGroupedSelected;
};
export const disableGroups = state => {
    return state.disableGroups;
};
export const comment = state => {
    return state.comment;
};
export const disableAll = state => {
    return state.disableAll;
};
